import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.bundle.min.js";
import "./adminassets/css/bootstrap.min.css";
import "./adminassets/css/bootstrap.min.css";
import Appointments from "./pages/appointments";
import BookingSuccess from "./pages/booking-success";
import Contactus from "./pages/contactus/contactus";
import DoctorProfile from "./pages/doctorprofile";
import Home1 from "./pages/home/home";
import Booking from "./pages/booking/booking1";
import MyProfile from "./pages/myProfile";
import Login from "./components/Login";
import { getSession } from "./pages/services/SessionManager";
import Terms from "./pages/terms";
import Dashboard from "./Dashboard/index.jsx";
import Profile from "./Dashboard/profile/index.jsx";
import Settings from "./Dashboard/settings/index.jsx";
import Services from "./Dashboard/Services/index.jsx";
import PastAppointments from "./Dashboard/appointList/index.jsx";
import Clients from "./Dashboard/clients/index.jsx";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const sessionData = getSession();

    if (token && sessionData && sessionData.isAuthenticated) {
      setIsLoggedIn(true);
    }
  }, []);

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    const session = getSession();
    
    if (!token || !session?.isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <BrowserRouter>
      <div className="main-wrapper">
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/about-us" element={<DoctorProfile />} />
          <Route
            path="/login"
            element={<Login setIsLoggedIn={setIsLoggedIn} />}
          />
          
          {/* Protected dashboard routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashprofile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/services"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/appointmentList"
            element={
              <ProtectedRoute>
                <PastAppointments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <ProtectedRoute>
                <Appointments />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
